import React from 'react';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet-async';
import GameIntro from '@/components/GameIntro';
import Features from '@/components/Features';
import CallToAction from '@/components/CallToAction';

const Home = () => {
  const intl = useIntl();

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-purple-100 to-indigo-200">
      <Helmet>
        <title>{intl.formatMessage({ id: 'home.seo.title' })}</title>
        <meta name="description" content={intl.formatMessage({ id: 'home.seo.description' })} />
      </Helmet>
      <h1 className="sr-only">{intl.formatMessage({ id: 'home.title' })}</h1>
      <GameIntro />
      <div id="game-area" className="flex-grow container mx-auto px-4 py-8 flex flex-col items-center">
        <h2 className="text-3xl font-bold text-indigo-800 mb-6 text-center">{intl.formatMessage({ id: 'home.startChallenge' })}</h2>
        <div className="game-wrapper w-full mb-8">
          <iframe 
            src="https://pokedle.io/pokedle.embed" 
            className="w-full h-full border-4 border-indigo-500 rounded-lg shadow-lg"
            title="Pokedle Game"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-indigo-800 mb-6 text-center">{intl.formatMessage({ id: 'home.about.title' })}</h2>
          <p className="text-lg text-gray-700 mb-6">
            {intl.formatMessage({ id: 'home.about.description1' })}
          </p>
          <p className="text-lg text-gray-700 mb-6">
            {intl.formatMessage({ id: 'home.about.description2' })}
          </p>
          <p className="text-lg text-gray-700 mb-6">
            {intl.formatMessage({ id: 'home.about.description3' })}
          </p>
          <h3 className="text-2xl font-semibold text-indigo-700 mb-4">{intl.formatMessage({ id: 'home.howToPlay.title' })}</h3>
          <ol className="list-decimal list-inside space-y-4 mb-8">
            <li className="text-lg">{intl.formatMessage({ id: 'home.howToPlay.item1' })}</li>
            <li className="text-lg">{intl.formatMessage({ id: 'home.howToPlay.item2' })}</li>
            <li className="text-lg">{intl.formatMessage({ id: 'home.howToPlay.item3' })}</li>
            <li className="text-lg">{intl.formatMessage({ id: 'home.howToPlay.item4' })}</li>
            <li className="text-lg">{intl.formatMessage({ id: 'home.howToPlay.item5' })}</li>
          </ol>
        </div>
      </section>
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-indigo-800 mb-6 text-center">{intl.formatMessage({ id: 'home.advancedStrategies.title' })}</h2>
          <ul className="list-disc list-inside space-y-4 mb-8">
            <li className="text-lg">{intl.formatMessage({ id: 'home.advancedStrategies.item1' })}</li>
            <li className="text-lg">{intl.formatMessage({ id: 'home.advancedStrategies.item2' })}</li>
            <li className="text-lg">{intl.formatMessage({ id: 'home.advancedStrategies.item3' })}</li>
            <li className="text-lg">{intl.formatMessage({ id: 'home.advancedStrategies.item4' })}</li>
            <li className="text-lg">{intl.formatMessage({ id: 'home.advancedStrategies.item5' })}</li>
          </ul>
        </div>
      </section>
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-indigo-800 mb-6 text-center">{intl.formatMessage({ id: 'home.faq.title' })}</h2>
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold text-indigo-700 mb-2">{intl.formatMessage({ id: 'home.faq.question1' })}</h3>
              <p className="text-lg text-gray-700">{intl.formatMessage({ id: 'home.faq.answer1' })}</p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-indigo-700 mb-2">{intl.formatMessage({ id: 'home.faq.question2' })}</h3>
              <p className="text-lg text-gray-700">{intl.formatMessage({ id: 'home.faq.answer2' })}</p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-indigo-700 mb-2">{intl.formatMessage({ id: 'home.faq.question3' })}</h3>
              <p className="text-lg text-gray-700">{intl.formatMessage({ id: 'home.faq.answer3' })}</p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-indigo-700 mb-2">{intl.formatMessage({ id: 'home.faq.question4' })}</h3>
              <p className="text-lg text-gray-700">{intl.formatMessage({ id: 'home.faq.answer4' })}</p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-indigo-700 mb-2">{intl.formatMessage({ id: 'home.faq.question5' })}</h3>
              <p className="text-lg text-gray-700">{intl.formatMessage({ id: 'home.faq.answer5' })}</p>
            </div>
          </div>
        </div>
      </section>
      <Features />
      <CallToAction />
    </div>
  );
};

export default Home;